export default function formatGMT(times: number[]) {
  return `GMT${times[0] > 0 ? "+" : ""}${times[0]} - GMT${
    times[1] > 0 ? "+" : ""
  }${times[1]}`.replace(/GMT0/g, "GMT");
}
